import './boxInfoOrbit3d.css';

export default function BoxInfoOrbit3d() {
  return (
    <div className="orbit-hint">
      <div className="orbit-hint-icon">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path
            fill="currentColor"
            d="M12,5A7,7 0 0,1 19,12A7,7 0 0,1 12,19A7,7 0 0,1 5,12A7,7 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
          />
        </svg>
      </div>
      <div className="orbit-hint-text">Interagisci</div>
    </div>
  );
}
